@let paginatedItems = (files$ | async);

<app-shared-table tableHead="solid" [columns]="fileColumns" [items]="paginatedItems?.documents || []"
    [totalItems]="paginatedItems?.totalItems || 0" [multiActions]="multiActions"
    (multiActionEvent)="$event.action === 'add' && openUploadModal()"
    [pageSize]="pagination.pageSize" [currentPage]="pagination.page"
    (pageChange)="updatePagination($event)" (sortChange)="updateSort($event)"
    (multiActionEvent)="$event.action === 'delete' && deleteDocuments($event.list)"
    (singleActionEvent)="$event.action === 'download' && openDocumentPreview($event.item)"
    [isLoading]="loading" [clickableRow]="false"
    [tableHeightElems]="5">
</app-shared-table>
